import type { Questionnaire } from '@medplum/fhirtypes'
import {
  getComputationAnswerOptions,
  getComputationQuestionnaireItem,
  VALIDATED_TOOL_SUMMARY_ITEM,
  VALIDATED_TOOL_TAG,
} from '#src/models/questionnaires/utils/index.ts'
import { QUESTIONNAIRE_ITEM_DISPLAY_LINK_URL } from '#src/structureDefinitions.ts'

const AD8_ANSWER_OPTIONS = getComputationAnswerOptions([
  { code: 'yes', score: 1 },
  { code: 'no', score: 0 },
  { code: 'na', score: 0 },
])

export const ad8Questionnaire = {
  resourceType: 'Questionnaire',
  url: 'https://www.seenhealth.org/fhir/Questionnaire/AD8',
  title: 'AD8 Dementia Screening Interview',
  name: 'AD8',
  status: 'active',
  subjectType: ['Patient'],
  meta: {
    tag: [VALIDATED_TOOL_TAG],
  },
  item: [
    {
      linkId: 'instructions',
      type: 'display',
      text: 'Remember, "Yes, a change" indicates that there has been a change in the last several years caused by cognitive (thinking and memory) problems.',
    },
    {
      linkId: QUESTIONNAIRE_ITEM_DISPLAY_LINK_URL,
      type: 'display',
      text: 'AD8 Reference PDF',
      extension: [
        {
          url: QUESTIONNAIRE_ITEM_DISPLAY_LINK_URL,
          valueString:
            'https://www.alz.org/getmedia/6e7291bf-4ac8-40ed-a148-824d4591ed7e/ad8-dementia-screening.pdf',
        },
      ],
    },
    {
      linkId: 'judgment',
      type: 'choice',
      text: 'Problems with judgment (e.g., problems making decisions, bad financial decisions, problems with thinking)',
      answerOption: AD8_ANSWER_OPTIONS,
    },
    {
      linkId: 'hobbies',
      type: 'choice',
      text: 'Less interest in hobbies/activities',
      answerOption: AD8_ANSWER_OPTIONS,
    },
    {
      linkId: 'repeats',
      type: 'choice',
      text: 'Repeats the same things over and over (questions, stories, or statements)',
      answerOption: AD8_ANSWER_OPTIONS,
    },
    {
      linkId: 'learning-tools',
      type: 'choice',
      text: 'Trouble learning how to use a tool, appliance, or gadget (e.g., VCR, computer, microwave, remote control)',
      answerOption: AD8_ANSWER_OPTIONS,
    },
    {
      linkId: 'month-year',
      type: 'choice',
      text: 'Forgets correct month or year',
      answerOption: AD8_ANSWER_OPTIONS,
    },
    {
      linkId: 'finances',
      type: 'choice',
      text: 'Trouble handling complicated financial affairs (e.g., balancing checkbook, income taxes, paying bills)',
      answerOption: AD8_ANSWER_OPTIONS,
    },
    {
      linkId: 'appointments',
      type: 'choice',
      text: 'Trouble remembering appointments',
      answerOption: AD8_ANSWER_OPTIONS,
    },
    {
      linkId: 'daily-problems',
      type: 'choice',
      text: 'Daily problems with thinking and/or memory',
      answerOption: AD8_ANSWER_OPTIONS,
    },
    getComputationQuestionnaireItem([
      { code: 'normal', score: 1 },
      { code: 'impaired', score: 8 },
    ]),
    VALIDATED_TOOL_SUMMARY_ITEM,
  ],
} satisfies Questionnaire
